export default ["M8 5a3 3 0 100 6 3 3 0 100-6z"];
